import styled from 'styled-components';

export const Container = styled.div``;

export const ModalContainer = styled.div`
  div.ModalBody {
    width: 480px;
    margin-left: -24px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 30px 47px 0 45px;
    background-color: #f7f7f7;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: 0.01px;
    color: #292929;
    div {
      width: 90%;
      /* padding-top: 15px; */
      padding-bottom: 15px;
      margin-bottom: 15px;
      border-bottom: 0.5px solid #eaeaea;
      span {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.23;
        letter-spacing: 0.01px;
        text-align: left;
        color: #999999;
      }
      p {
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.19;
        letter-spacing: 0.01px;
        text-align: left;
        color: #292929;
      }
      p.mesesPendentes {
        font-weight: bold;
      }
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 30px;

  div.iconModal {
    width: 80px;
    height: 80px;
    margin-right: 20px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 5px;
    span {
      width: 50px;
      height: 50px;
      display: block;
      border-radius: 50%;
      background-color: #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    svg {
      color: #cc0000;
    }
  }

  h2 {
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
    span {
      color: #cc0000;
      font-weight: bold;
    }
  }
`;

export const ModalFooter = styled.div`
  /* width: 100%; */
  width: 480px;
  padding-bottom: 30px;
  margin-bottom: -26px;
  margin-left: -24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f7;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const ButtonModal = styled.button`
  width: 168.8px;
  height: 40.1px;
  border-radius: 3.5px;
  border: none;
  background-color: ${props => (props.cancel ? '#f7f7f7' : '#cc0000')};
  color: ${props => (props.cancel ? '#999999' : '#f7f7f7')};
  margin: 20px 10px 0px 10px;
`;
